import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { toast } from "react-toastify";

import InputField from "../ui/InputField";
import SelectField from "../ui/SelectField";

const TIPOS_MOVIMIENTO = [
  { _id: "all", name: "Todos los movimientos" },
  { _id: "Ingreso", name: "Ingreso" },
  { _id: "Salida", name: "Salida" },
  { _id: "Transferencia", name: "Transferencia" },
];

const ModalReporteAlmacen = ({ onClose }) => {
  const [almacenes, setAlmacenes] = useState([
    { _id: "all", nombre: "Todos los almacenes" },
  ]);
  const [items, setItems] = useState([
    { codigo_item: "all", articulo: "Todos los artículos" },
  ]);

  const [almacenId, setAlmacenId] = useState("all");
  const [tipoMovimiento, setTipoMovimiento] = useState("all");
  const [codigoItem, setCodigoItem] = useState("all");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [resAlm, resItems] = await Promise.all([
          axios.get(`${API}/almacenes`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API}/stock/items`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);
        setAlmacenes([
          { _id: "all", nombre: "Todos los almacenes" },
          ...(Array.isArray(resAlm.data) ? resAlm.data : []),
        ]);
        setItems([
          { codigo_item: "all", articulo: "Todos los artículos" },
          ...(Array.isArray(resItems.data) ? resItems.data : []),
        ]);
      } catch {
        toast.error("Error al cargar datos del almacén");
      }
    };
    fetchData();
  }, [API, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "almacen") setAlmacenId(value);
    if (name === "tipo") setTipoMovimiento(value);
    if (name === "articulo") setCodigoItem(value);
    if (name === "fechaInicio") setFechaInicio(value);
    if (name === "fechaFin") setFechaFin(value);
  };

  const handleGenerarReporte = async () => {
    if (!fechaInicio || !fechaFin) {
      toast.warning("Seleccione el rango de fechas");
      return;
    }

    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("fechaInicio", fechaInicio);
      params.append("fechaFin", fechaFin);
      if (almacenId !== "all") params.append("almacenId", almacenId);
      if (tipoMovimiento !== "all")
        params.append("tipoMovimiento", tipoMovimiento);
      if (codigoItem !== "all") params.append("codigoItem", codigoItem);

      const res = await axios.get(
        `${API}/reportes/almacen?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        },
      );

      const contentType = res.headers["content-type"];
      if (contentType.includes("application/pdf")) {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "reporte_almacen.pdf";
        link.click();
        toast.success("Reporte de almacén generado ✅");
        onClose();
      } else {
        const text = await res.data.text();
        const json = JSON.parse(text);
        if (json.success === false) toast.info(json.message);
        else toast.error("No se pudo generar el reporte");
      }
    } catch (err) {
      toast.error("Error al generar el reporte");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-2xl max-h-[90vh] bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">
            Reporte de Movimientos de Almacén
          </h2>
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="p-6 space-y-4">
            <SelectField
              label="Almacén"
              name="almacen"
              value={almacenId}
              options={almacenes}
              onChange={handleChange}
              displayFn={(a) => a.nombre}
            />

            <SelectField
              label="Tipo de movimiento"
              name="tipo"
              value={tipoMovimiento}
              options={TIPOS_MOVIMIENTO}
              onChange={handleChange}
            />

            <SelectField
              label="Artículo"
              name="articulo"
              value={codigoItem}
              options={items}
              onChange={handleChange}
              valueKey="codigo_item"
              displayFn={(i) =>
                i.codigo_item === "all"
                  ? i.articulo
                  : `[${i.codigo_item}] ${i.articulo}`
              }
            />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <InputField
                label="Fecha inicio"
                type="date"
                name="fechaInicio"
                value={fechaInicio}
                onChange={handleChange}
              />
              <InputField
                label="Fecha fin"
                type="date"
                name="fechaFin"
                value={fechaFin}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 p-6 border-t">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={handleGenerarReporte}
            disabled={isLoading}
            className="bg-blue-600 text-white hover:bg-blue-700"
          >
            {isLoading ? "Generando..." : "Generar Reporte"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalReporteAlmacen;
